import { unstable_registerNextDomDrop } from "polotno/config";
import { useState } from "react";

const Attribute = ({ label, value, handleAttributeClick, store, isTemplateMode = false, variableName }) => {
    const [isDragging, setIsDragging] = useState(false);
    const finalVariableName = variableName || label.toLowerCase();

    return (
        <div
            draggable={true}
            onDragStart={() => {
                setIsDragging(true);
                unstable_registerNextDomDrop((pos, element) => {
                    if (element && element.type === "text") {
                        // Update existing text element
                        element.set({ 
                            text: value,
                            ...(isTemplateMode && {
                                custom: {
                                    ...element.custom,
                                    isVariable: true,
                                    variableName: finalVariableName,
                                    variableType: 'text'
                                }
                            })
                        });
                        return;
                    }

                    // Create new text element if not dropping onto existing text
                    store.activePage.addElement({
                        type: "text",
                        text: value,
                        width: 200,
                        x: pos.x,
                        y: pos.y,
                        fontSize: 30,
                        fill: "#000", // Text color
                        fontFamily: "Arial",
                        ...(isTemplateMode && {
                            custom: {
                                isVariable: true,
                                variableName: finalVariableName,
                                variableType: 'text'
                            }
                        })
                    });
                });
            }}
            onDragEnd={() => {
                setIsDragging(false);
                unstable_registerNextDomDrop(null); // Cleanup
            }}
            className={`h-[110px] cursor-pointer w-[121px] bg-[#F2F3F5] p-3 rounded-md flex flex-col items-start justify-start transition-shadow ${isDragging ? "shadow-lg border-2 border-[#8E0DFF]" : ""
                } ${isTemplateMode ? "border-2 border-dashed border-[#8E0DFF]" : ""}`}
        >
            <h2 className="text-[#8E0DFF] text-sm font-semibold mb-[10px] flex items-center gap-1">
                {isTemplateMode && <span className="text-xs">📝</span>}
                {label}
            </h2>
            <p className="text-sm font-semibold text-[#4A4A4A] text-left line-clamp-3 overflow-hidden text-wrap break-words">
                {value}
            </p>
            {isTemplateMode && (
                <span className="text-[10px] text-[#8E0DFF] mt-auto">{`{${finalVariableName}}`}</span>
            )}
        </div>
    );
};


export default Attribute;
